import React, { useEffect } from 'react';
import { StyledConnectAccountSteps } from './ConnectAccountStepsStyles';
import dummyImg from '../../../../assets/avatar-2.svg';
import { FaLinkedinIn } from 'react-icons/fa';
import Button from '../../../molecules/Button';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../../Context/authContext';

const Verify = ({ onClose, accountData, activeProfile }) => {
  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));

  function handleClose() {
    refetch();
    onClose();
  }
  return (
    <StyledConnectAccountSteps ContentCenter>
      <div className="verify-step">
        <div className="img-wrapper">
          <div className="img-holder">
            <img src={accountData?.profile?.profile_photo || dummyImg} alt="profileImg" width={100} height={100} />
          </div>
          <div className="icon-holder">
            <FaLinkedinIn color="var(--white)" size={14} />
          </div>
        </div>
        <span className="user-name">
          {accountData?.profile?.first_name || activeProfile?.firstName}
          &nbsp;
          {accountData?.profile?.last_name || activeProfile?.lastName}
        </span>
        {/* <span className="designation">Founder & CEO of Alison</span> */}
        <div className="tag">Connected Successfuly</div>
      </div>
      <div className="btn-holder">
        <div className="btn-wrap">
          <Button newStyle variant="outline" width="155px" type="button" onClick={() => handleClose()}>
            Cancel
          </Button>
        </div>
        <Button newStyle variant="darkBlue" type="submit" rounded width="155px" onClick={() => handleClose()}>
          Open Details
        </Button>
      </div>
    </StyledConnectAccountSteps>
  );
};

export default Verify;
